<template>
  <div class="coupon-container">
    <div class="coupon-title">
      <div class="coupon-img">
        <img
          :src="require('@/assets/img/icon/svg/icon-coupon-black.svg')"
          alt=""
        />
      </div>
      <div class="coupon-name">
        {{ coupon.name }}
      </div>
    </div>
    <div class="coupon-text" v-html="newlineConvert(masterCoupon.comment)" />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheCouponNameAndComment",
  setup() {
    const store = useStore();

    const coupon = computed(() => store.getters["coupon/externalCoupon"]);
    const masterCoupon = computed(() => store.getters["coupon/masterCoupon"]);

    return {
      coupon,
      masterCoupon,
    };
  },
};
</script>
<style scoped lang="scss">
.coupon-title {
  padding: 20px 10px;
  display: flex;
  align-items: center;
  background: #f2f2f2;
  font-size: 17px;
  font-weight: 700;
  line-height: 25px;
}

.coupon-img {
  height: 25px;

  > img {
    height: 25px;
  }
}

.coupon-name {
  margin-left: 10px;
}

.coupon-text {
  margin-top: 25px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #333333;
}
</style>
